import { useCallback, useEffect, useRef } from 'react';

function useHandleSearchInputChange({
    debounceTime = 500,
    nameFilter,
    setFilter,
}) {
    const timeoutRef = useRef(null);
    const cb = useCallback(
        (value) => {
            try {
                if (timeoutRef.current) {
                    clearTimeout(timeoutRef.current);
                }
                if (value && value !== nameFilter) {
                    timeoutRef.current = setTimeout(() => {
                        setFilter('name', [value]);
                    }, debounceTime);
                } else if (!value && nameFilter) {
                    setFilter('name', []);
                }
            } catch (err) {
                console.error(err);
            }
        },
        [nameFilter, setFilter],
    );
    useEffect(
        () => () => {
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        },
        [],
    );
    return cb;
}

export default useHandleSearchInputChange;
